import styled from 'styled-components';

import { Flex, gridSizes } from 'utils/style';

import SuggestedItemSeparator from 'components/form/SuggestedTimes/SuggestedItemSeparator/component';

export default styled(SuggestedItemSeparator)`
  text-transform: uppercase;
  color: var(--grey700);
  background-color: var(--white-caniche);
  height: 32px;
  padding: 0 ${gridSizes('S')};
  ${Flex.row};
  align-items: center;
`;
